<template>
  <el-drawer
    custom-class="client-drawer integral-record-drawer"
    v-model="drawer.show"
    append-to-body
    :destroy-on-close="true"
  >
    <template #header>
      <h4>积分记录</h4>
    </template>

    <template #default>
      <div class="integral-exchange">
        <div class="left">
          <h5>积分
            
            <el-popover
                placement="top-start"
                popper-class='form-pop'
                :width="430"
                trigger="hover"
            >
                <template #reference>
                    <ab-svg name="my-issue" style="cursor: pointer"></ab-svg>
                </template>
                <template #default>
                    <p>积分说明：</p> 
                    <p>1、新客户完成签约将获得300积分</p>
                    <p>2、按下单金额赠送积分，不满2W美金，统一赠送10积分；2W美金以上，向下取整按10积分的倍数递增，封顶100积分。例如：19999美金赠送10积分；20001美金赠送20积分；30001美金赠送30积分，以此类推。</p>
                    <p>3、通过一咻通关平台每日签到后，可获得1积分</p>
                    <p>4、10积分兑换1元，可折算成账户余额显示，可用做抵扣服务费或兑换礼品</p>
                    <p>5、兑换礼品请联系客服</p>
                    <p>积分规则即日起生效，若发生变化再另外通知</p>
                </template>
            </el-popover>
          </h5>
          <div style="font-family: DIN_Condensed_Bold">{{ totalIntegral || 0 }}</div>
        </div>
        <div class="right">
          <h5>兑换</h5>
          <div>
            <el-input
              v-model.trim="redeemPoints"
              placeholder="请输入兑换积分"
            />
            <el-button
              type="primary"
              @click="confirmExchange"
              :disabled="!redeemPoints || redeemPoints > totalIntegral || !/^[0-9]+$/.test(redeemPoints)"
            >
              确定
            </el-button>
          </div>
        </div>
      </div>

      <div
        class="integral-list"
        v-infinite-scroll="load"
        infinite-scroll-immediate="false"
        infinite-scroll-distance='200'
        infinite-scroll-delay='200'
      >
        <div
          class="integral-list-detail"
          v-for="(item, index) in intTableData"
          :key="index"
        >
          <div>
            <h5>{{item.remark}}</h5>
            <p>{{ item.createTime}}</p>
          </div>
          <div
            class="val green"
            v-if="item.integral>0"
          >+{{ item.integral}}</div>
          <div
            class="val red"
            v-else
          >{{ item.integral }}</div>
        </div>
      </div>
    </template>
  </el-drawer>
</template>

<script>
export default {
  name: 'integral-record', // 积分记录
  props: {
    totalIntegral: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      drawer: {
        show: false
      },
      redeemPoints: '', //积分兑换值
      intTableData: [],
      //积分记录页码
      integralPage: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },

  computed: {},
  created() {},
  emits:['exchange'],
  methods: {
    init() {
      this.drawer.show = true
      this.getIntegral()
    },

    getIntegral() {
      let data = {
        data: { type: 'COMPANY' },
        pageNum: this.integralPage.currentPage,
        pageSize: this.integralPage.pageSize
      }
      this.$post('/oms/client/integral/detail', data).then(({ data }) => {
        if (data.code === 'C0000') {
            if (data.result && data.result.list && data.result.list.length > 0) {
                this.intTableData = this.intTableData.concat(data.result.list)
                this.integralPage.total = data.result.total
            }
        }
      })
    },
    
    //积分记录数据滚动加载
    load() {
      if (this.integralPage.currentPage * this.integralPage.pageSize <this.integralPage.total) {
        this.integralPage.currentPage++
        this.getIntegral()
      }
    },
    //初始化
    initialize(){
        this.intTableData=[]
        this.integralPage.currentPage=1
        this.getIntegral()
    },
    //抽屉，积分兑换
    confirmExchange() {
      this.$get('/oms/principalIntegral/exchange', {
        integral: this.redeemPoints
      }).then(({ data }) => {
        if (data.code === 'C0000') {
          if (data.result) {
            this.$message({
              type: 'success',
              message: `成功兑换${data.result}元!`,
              offset: 380,
              grouping: true
            })
            this.redeemPoints = ''
            this.initialize()
            this.$emit('exchange')
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
//积分记录
.integral-record-drawer {
  text-align: left;
  color: #000000;
  font-weight: 400;
  .integral-exchange {
    display: flex;
    padding-bottom: 30px;

    .left {
      width: 35%;
      border-right: 1px solid #d2d2d2;
      h5 {
        margin-bottom: 7px;
        font-size: 14px;
        .icon-svg {
          width: 14px;
          height: 14px;
          margin: 3px 0 0 3px;
          vertical-align: top;
        }
      }
      div {
        font-size: 48px;
        color: #0a7cff;
        font-weight: 500;
      }
    }
    .right {
      width: 65%;
      padding-left: 40px;

      h5 {
        margin-bottom: 20px;
        font-size: 14px;
      }
      & > div {
        display: flex;
        button {
          margin-left: 20px;
        }
      }
    }
  }

  .integral-list {
    .integral-list-detail {
      padding: 20px 0;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #f0f2f5;
      h5 {
        font-size: 16px;
        margin-bottom: 15px;
        color: #000;
      }
      p {
        color: #757575;
        font-size: 14px;
      }
      .val {
        margin-top: 20px;
        font-size: 24px;
        font-weight: 500;
        font-family: DIN_Condensed_Bold
      }
      .green {
        color: #0ab2a8;
      }
      .red {
        color: #ff0000;
      }
      &:first-child {
        border-top: 1px solid #f0f2f5;
      }
    }
  }
  
}
</style>